import { type TrackingLabelProviderGroup } from '@cart-services/utils/official-website-order-shipments'
import { useDialog } from '@dni-hooks/useDialog'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { ArrowRightSmall, LinkSquare } from '@pets-ui/Icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'
import { DIALOG_TRACKING_LABEL_STATUS_KEY, type DialogTrackingLabelStatusExtraProps } from './DialogTrackingLabelStatus'

interface TrackingLabelSummaryProps {
  trackingLabelProviderGroup: TrackingLabelProviderGroup
}

export function TrackingLabelSummary({ trackingLabelProviderGroup }: TrackingLabelSummaryProps) {
  const { t } = useTranslation()
  const { provider_name, statusGroups } = trackingLabelProviderGroup
  const { openDialog } = useDialog<DialogTrackingLabelStatusExtraProps>(DIALOG_TRACKING_LABEL_STATUS_KEY)
  const allTrackingLabels = statusGroups.flatMap(({ trackingLabels }) => trackingLabels)
  const singleTrackingLabel = allTrackingLabels.length === 1 ? allTrackingLabels[0] : null
  const singleTrackingUrl = singleTrackingLabel?.tracking_url ?? undefined
  const isMultipleTrackingLabels = !singleTrackingLabel

  const trackingDisplay = singleTrackingLabel
    ? (
      <HStack gap={1} color={colors.grey800}>
        <Text>{singleTrackingLabel.tracking_no}</Text>
        {singleTrackingUrl && (
          <IconButton onClick={() => window.open(singleTrackingUrl, '_blank', 'noopener,noreferrer')} fontSize={15}>
            <LinkSquare color={colors.grey600} />
          </IconButton>
        )}
      </HStack>
    )
    : <Text>{t('orderDetail.shipmentSplitIntoParcels', { count: allTrackingLabels.length, defaultValue: '商品將拆分成 {{count}} 件貨物運送' })}</Text>

  const handleOpenDialog = () => openDialog({ trackingLabelGroup: trackingLabelProviderGroup })

  return (
    <HStack
      backgroundColor={colors.blueGrey50}
      borderRadius="4px"
      justifyContent="space-between"
      alignItems="center"
      p="10px"
      onClick={isMultipleTrackingLabels ? handleOpenDialog : undefined}
      cursor={isMultipleTrackingLabels ? 'pointer' : undefined}
    >
      <VStack>
        <Text variant="subtitle" color={colors.blueGrey800}>{`${provider_name}： ${statusGroups.map(({ tracking_status_name }) => tracking_status_name ?? '').join('、')}`}</Text>
        {trackingDisplay}
      </VStack>
      {isMultipleTrackingLabels && (
        <IconButton>
          <ArrowRightSmall />
        </IconButton>
      )}
    </HStack>
  )
}
